import {memo} from 'react';
import {Badge, Tooltip} from "@mantine/core";


interface VersionBadgeProps {
  version: number | undefined;
}

export const VersionBadge = memo(({version}: VersionBadgeProps) => {
  if (version === 1 || version === null) {
    return (
      <Tooltip label="Hyper-only timing (legacy)">
        <Badge color="yellow" variant="light">v1</Badge>
      </Tooltip>
    );
  } else if (version === 2) {
    return (
      <Tooltip label="Sublight-aware system for HEPs in gravity wells">
        <Badge color="green" variant="light">v2</Badge>
      </Tooltip>
    );
  } else {
    return (
      <Tooltip label="">
        <Badge color="yellow" variant="light">Unknown Version</Badge>
      </Tooltip>
    );
  }
});
